module.exports = __webpack_public_path__ + "img/whatsapp.18fb83dc.svg";